export default __webpack_public_path__ + "static/media/product33.a890211a.png";